import genres from "@/data/genres-data";
import { getGenres } from "@/services/genre-service";
import { Genre } from "@/types/GenreTye";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import ms from 'ms';

const useGenres = () => {
    return useQuery<Genre[], Error>({
        queryKey: ["genres"],
        queryFn: getGenres,
        placeholderData: keepPreviousData,
        initialData: genres,
        staleTime: ms('24h'),
    });
}

export default useGenres;
